import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TaxctcService } from '../../../../_services/taxctc/taxctc.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';

@Component({
  selector: 'app-arrears-form',
  templateUrl: './arrears-form.component.html',
  styleUrls: ['./arrears-form.component.scss']
})
export class ArrearsFormComponent implements OnInit {
  arrearsform 
  rowData: any;
  form: FormGroup;
  tenantId: string;
  currentUser: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  arrearsId: any;
  getUserName: any;
  userDropdownList = [];
  taxregimDropdownList = [];
  tdsIgnoreMonthsArray : any[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService, 
    private allocationService: AllocationService,
    private router: Router,
    private route: ActivatedRoute,
    private taxctcService :TaxctcService
  ) { 
    this.arrearsform = this.formBuilder.group({
    employeeId: new FormControl(''),
    financialYear: new FormControl(''),
    ctc: new FormControl(''),
    startMonth: new FormControl(''),
    endMonth: new FormControl(''),
    componentName: new FormControl(''),
    componentValue: new FormControl(''),
    miscellaneous: new FormControl(''),
    deduction: new FormControl(''),
    taxRegimeNo: new FormControl(''),
    employeeName: new FormControl(''),
    tdsIgnoreMonths: new FormControl(''),
    tdsIgnoreMonthsValues: new FormControl(''),
    absolute: new FormControl(''),
    type: new FormControl('')
  })
}

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.arrearsform.value.componentName = "Arrears";
    this.arrearsform.patchValue(this.arrearsform.value);
    this.arrearsId = this.route.snapshot.paramMap.get('id');
    if (this.arrearsId) this.getUserArrearsById(this.arrearsId)
    this.getUserList();
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getUserArrearsById(id){
    this.taxctcService.getuserCtcsById(id).subscribe((response) => {
      if(response) {
        this.arrearsform.patchValue(response);
        const array = response.tdsIgnoreMonths?.split(',');
        this.arrearsform.value.tdsIgnoreMonths = array;
        this.arrearsform.value.employeeId = this.arrearsform.value.employeeId + " . " + this.arrearsform.value.employeeName;
        this.arrearsform.patchValue(this.arrearsform.value);
      }
    }, (error) =>{
      
    });
  }

  createUserArrears() {
    let tdsIgnoredMonth = this.arrearsform.get('tdsIgnoreMonths').value?.toString();
    let details = {
      employeeId: this.arrearsform.get('employeeId') ? this.arrearsform.get('employeeId').value.split(' . ')[0] : null,
      employeeName: this.arrearsform.get('employeeId') ? this.arrearsform.get('employeeId').value.split(' . ')[1] : null,
      financialYear: this.arrearsform.get('financialYear').value,
      ctc: this.arrearsform.get('ctc').value,
      startMonth: this.arrearsform.get('startMonth').value,
      endMonth: this.arrearsform.get('endMonth').value,
      componentName: this.arrearsform.get('componentName').value,
      componentValue: this.arrearsform.get('componentValue').value,
      miscellaneous: this.arrearsform.get('miscellaneous').value,
      deduction: this.arrearsform.get('deduction').value,
      taxRegimeNo: this.arrearsform.get('taxRegimeNo').value,
      tdsIgnoreMonths: tdsIgnoredMonth,
      tdsIgnoreMonthsValues: this.arrearsform.get('tdsIgnoreMonthsValues').value,
      absolute: this.arrearsform.get('absolute').value,
      type: "arrears"
    }
    this.taxctcService.createuserCtcs(details).subscribe((response: any) => {
      // update grid after creating new contact & close the modal
      this.backToArrearsList();
    });
  }

  backToArrearsList() {
    this.router.navigate([this.tenantId + '/dashboard/finance/arrears']);
  }

  updateUserArrears() {
    let tdsIgnoredMonth = this.arrearsform.get('tdsIgnoreMonths').value?.toString();
    let details = {
      //id: this.taxmetadataform.get('id').value,
      employeeId: this.arrearsform.get('employeeId') ? this.arrearsform.get('employeeId').value.split(' . ')[0] : null,
      employeeName:this.arrearsform.get('employeeId') ? this.arrearsform.get('employeeId').value.split(' . ')[1] : null,
      financialYear: this.arrearsform.get('financialYear').value,
      ctc: this.arrearsform.get('ctc').value,
      startMonth: this.arrearsform.get('startMonth').value,
      endMonth: this.arrearsform.get('endMonth').value,
      componentName: this.arrearsform.get('componentName').value,
      componentValue: this.arrearsform.get('componentValue').value,
      miscellaneous: this.arrearsform.get('miscellaneous').value,
      deduction: this.arrearsform.get('deduction').value,
      taxRegimeNo: this.arrearsform.get('taxRegimeNo').value,
      tdsIgnoreMonths: tdsIgnoredMonth,
      tdsIgnoreMonthsValues: this.arrearsform.get('tdsIgnoreMonthsValues').value,
      absolute: this.arrearsform.get('absolute').value,
      type: "arrears"
    }
    // console.log("details", details)
    this.taxctcService.updateuserCtcs(details, this.arrearsId).subscribe(res => {
      this.selectedCheckboxData = [];
      this.backToArrearsList();
    });
  }

}